import { flow } from "fp-ts/lib/function";
import { type IntlShape } from "react-intl";

import { type LensDestination } from "../../gql-generated/types";
import { type LensFolderRoleTypePermissions } from "../../shared/constants";
import { type LensProps } from "../hooks/LensProps";

import { type LensActionsState } from "./LensActionsState";
import { makeLensActionsConfigBasedOnStatus } from "./makeLensActionsConfigBasedOnStatus";
import {
    setDeleteLensPermissions,
    setEnrollCreatorPayoutPermissions,
    setFinalizePermissions,
    setLensCtaPermissions,
    setManageDigitalGoodsPermissions,
    setPublishToSnapchatPermissions,
    setScanCodePermissions,
    setSetVisibilityPermissions,
} from "./setLensPermissions";

export const makeLensActionsState = (
    lensProps: LensProps,
    destinations: readonly LensDestination[],
    intl: IntlShape,
    lensFolderPermissions: LensFolderRoleTypePermissions,
    lensMakerDebugEnabled: boolean,
): LensActionsState => {
    const { status, qrCode } = lensProps;

    const baseActionsConfig = makeLensActionsConfigBasedOnStatus(status);

    return flow(
        setScanCodePermissions(qrCode),
        setDeleteLensPermissions(lensProps, destinations, intl, lensFolderPermissions),
        setPublishToSnapchatPermissions(lensProps, lensFolderPermissions, lensMakerDebugEnabled),
        setSetVisibilityPermissions(lensFolderPermissions, lensProps, lensMakerDebugEnabled),
        setEnrollCreatorPayoutPermissions(lensFolderPermissions),
        setManageDigitalGoodsPermissions(lensProps),
        setFinalizePermissions(lensProps),
        setLensCtaPermissions(lensProps, lensMakerDebugEnabled),
    )({ actionsConfig: baseActionsConfig, lensActionsErrorMap: {} });
};
